import React from 'react';
import { Typography } from 'fronton-react';
import { benifitsStyles } from './styles';
import { BenefitList } from './components/benefit-list';

export const Benefits = () => {
	return (
		<div className={benifitsStyles}>
			<Typography className="title" variant="h2" as="h2">
				Закажите черновые работы в Лемана ПРО
			</Typography>
			<BenefitList />
		</div>
	);
};
